import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const recommendationsStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const recommendationsSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const recommendationsError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const recommendationsCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.RECOMMENDATIONS_START]: recommendationsStart,
  [Types.RECOMMENDATIONS_SUCCESS]: recommendationsSuccess,
  [Types.RECOMMENDATIONS_ERROR]: recommendationsError,
  [Types.RECOMMENDATIONS_CLEAN_UP]: recommendationsCleanUp,
};

export default createReducer(INITIAL_STATE, HANDLERS);
